import { instanceApi } from '../../services';
import { UpdateNotification } from '../../models';

export const getNotifications = (): Promise<any> => instanceApi.get('nms/Notification/GetNotifications');

export const updateNotificationStatus = (updateNotification: UpdateNotification): Promise<any> => instanceApi.post('nms/Notification/UpdateReadStatus', updateNotification);
